import { createAction, props } from '@ngrx/store';

const GET_CUSTOM_COMPONENT = '[CustomComponent] Get CustomComponent';
const SET_CUSTOM_COMPONENT = '[CustomComponent] Set CustomComponent';
const SAVE_CUSTOM_COMPONENT = '[CustomComponent] Save CustomComponent';
const SENT_CUSTOM_COMPONENTS = '[CustomComponent] Sent CustomComponent';
const UPDATE_CUSTOM_COMPONENT = '[CustomComponent] Update CustomComponent';
const DELETE_CUSTOM_COMPONENT = '[CustomComponent] Delete CustomComponent';
const SENT_DELETE_CUSTOM_COMPONENT = '[CustomComponent] Delete Sent CustomComponent';
const GETALL_CUSTOM_COMPONENT = '[CustomComponent] Get All CustomComponent';
const GETALL_CUSTOM_COMPONENT_SORTING = '[CustomComponent] Get All CustomComponent With Sorting';
const SETALL_CUSTOM_COMPONENT = '[CustomComponent] Set All CustomComponent';
const SETALL_CUSTOM_COMPONENT_SORTING = '[CustomComponent] Set All CustomComponent With Sorting';
const clearCC = createAction('[CustomComponent] clear request');
const getCustomComponent = createAction(GET_CUSTOM_COMPONENT, props<{ getCCcApiConstants: any; ccId: any }>());

const setCustomComponent = createAction(SET_CUSTOM_COMPONENT, props<{ currentCC: any }>());
const sentCustomComponents = createAction(SENT_CUSTOM_COMPONENTS, props<{ saveCCApiConstants: any; ccData: any }>());

const saveCustomComponent = createAction(SAVE_CUSTOM_COMPONENT, props<{ ccData: any }>());

const updateCustomComponent = createAction(UPDATE_CUSTOM_COMPONENT, props<{ saveCCApiConstants: any; ccData: any }>());

const deleteCustomComponent = createAction(DELETE_CUSTOM_COMPONENT, props<{ ccId: string }>());

const sentDeleteCustomComponent = createAction(
  SENT_DELETE_CUSTOM_COMPONENT,
  props<{ deleteCCApiConstants: any; ccId: string }>()
);

const getAllCustomComponent = createAction(GETALL_CUSTOM_COMPONENT, props<{ getAllCCApiConstants: any }>());

const getAllCustomComponentWithSorting = createAction(
  GETALL_CUSTOM_COMPONENT_SORTING,
  props<{ getAllCCApiConstants: any; filters: any }>()
);

const setAllCustomComponent = createAction(SETALL_CUSTOM_COMPONENT, props<{ allCCs: any }>());

const setAllCustomComponentWthSorting = createAction(SETALL_CUSTOM_COMPONENT_SORTING, props<{ allCCs: any }>());

const getAllCustomComponentForApp = createAction(GETALL_CUSTOM_COMPONENT, props<{ getAllCCForApp: any }>());

const setAllCustomComponentForApp = createAction(SETALL_CUSTOM_COMPONENT, props<{ allCCForApp: any }>());

export {
  getCustomComponent,
  clearCC,
  setCustomComponent,
  sentCustomComponents,
  setAllCustomComponentWthSorting,
  saveCustomComponent,
  getAllCustomComponentWithSorting,
  updateCustomComponent,
  deleteCustomComponent,
  sentDeleteCustomComponent,
  getAllCustomComponent,
  setAllCustomComponent,
  getAllCustomComponentForApp,
  setAllCustomComponentForApp
};
